import { useIntl } from "react-intl";
import { useLanguage } from "../../hooks/use-language.js";
import { Button } from "../ui/button.js";

export function LangToggle() {
  const intl = useIntl();
  const { language, setLanguage } = useLanguage();
  const next = language === "de" ? "en" : "de";

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={() => setLanguage(next)}
      aria-label={`${intl.formatMessage({ id: "lang.label" })}: ${intl.formatMessage({ id: `lang.${next}` })}`}
    >
      <span className="text-xs uppercase tracking-wide">{language}</span>
    </Button>
  );
}
